import React, { memo } from 'react';
import { Tooltip, Progress, Tag } from 'antd';
import { UploadedCSV, calPercent } from './utils';
import sum from 'lodash/sum';

type CSVStatusProps = { data: UploadedCSV };

function CSVStatus(props: CSVStatusProps) {
  const { data } = props;
  if (data.status === 'scheduled') return <Tag color="cyan">Scheduled</Tag>;

  if (!data.totalRows) {
    return <></>;
  }

  const totalSkipped = sum([
    data.unsubscribedCount,
    data.throttledCount,
    data.invalidCount,
    data.duplicateCount,
    data.cappedCount,
    data.suspendedDevsCount,
    data.inactiveAccountCount,
  ]);

  const totalProcessed = sum([data.sentCount, data.failedCount, totalSkipped]);

  const toDo =
    data.status === 'processing'
      ? `/ ${data.totalRows - totalProcessed} to do`
      : '';

  const tip =
    data.status === 'processing'
      ? `${data.sentCount} sent / ${data.failedCount} failed / ${totalSkipped} skipped ${toDo} -- ${totalProcessed}`
      : '';

  const progressPercentage = calPercent(data.totalRows, totalProcessed);

  let progressStatus = 'active';
  let strokeColor;
  if (data.isPaused) {
    progressStatus = 'normal';
    strokeColor = 'yellow';
  } else if (data.isAborted) {
    progressStatus = 'normal';
    strokeColor = 'red';
  } else if (progressPercentage === 100) {
    progressStatus = 'success';
  }

  return (
    <Tooltip title={tip}>
      <Progress
        percent={Number(progressPercentage.toFixed(1))}
        showInfo={!data.isAborted}
        status={progressStatus}
        strokeColor={strokeColor}
      />
    </Tooltip>
  );
}

export default memo(CSVStatus);
